<template>
  <div id="perSession">
    <div class="leftLabel">
      <div class="labelText">
        {{ $t('oa.activeSession.numberOfActiveLeaders') }}
      </div>
    </div>

    <div class="graphWrap">
      <div
        ref="chartdiv"
        class="hello"
      ></div>
      <el-tooltip
        class="csTooltip"
        effect="dark"
        :content="$t('oa.activeSession.coachSelection')"
        placement="bottom"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>

      <div class="bottomLabel">
        <div>
          {{ $t('oa.activeSession.session') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesAnimated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themesAnimated);

export default {
  props: {
    chartData: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      chart: null,
    };
  },

  computed: {
    fontColor() {
      return getComputedStyle(document.getElementById('app')).getPropertyValue('--themeFontColor');
    },

    formattedChartData() {
      const data = [];

      Object.keys(this.chartData).forEach((session) => {
        let format = '0';
        if (session.includes('board')) {
          format = 'CS';
        } else {
          // eslint-disable-next-line prefer-destructuring
          format = session.split('_')[1];
        }

        data.push({
          // session: this.$t(`session.${session}`),
          session: format,
          leader: this.chartData[session],
        });
      });

      return data;
    },
  },

  mounted() {
    am4core.addLicense(process.env.VUE_APP_AMCHARTS_LICENSE);
    this.chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

    this.chart.data = this.formattedChartData;

    // Create X axes
    const categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    // // Label
    categoryAxis.renderer.labels.template.fill = am4core.color(this.fontColor);
    // // Grid
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.grid.template.stroke = am4core.color(this.fontColor);
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.minGridDistance = 30;
    // // Stroke
    categoryAxis.dataFields.category = 'session';
    categoryAxis.renderer.line.stroke = am4core.color(this.fontColor);
    categoryAxis.renderer.line.strokeWidth = 1;
    categoryAxis.renderer.line.strokeOpacity = 1;

    // categoryAxis.renderer.labels.template.adapter.add('dy', (dy, target) => {
    //   if (target.dataItem && target.dataItem.index % 2 === 1) {
    //     return dy + 15;
    //   }
    //   return dy - 5;
    // });

    // Create Y axes
    const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    // // Label
    valueAxis.renderer.labels.template.fill = am4core.color(this.fontColor);
    // // Grid
    valueAxis.renderer.grid.template.stroke = am4core.color(this.fontColor);
    valueAxis.renderer.grid.template.strokeOpacity = 0.5;
    valueAxis.renderer.minGridDistance = 80;
    // // Stroke
    valueAxis.renderer.line.stroke = am4core.color(this.fontColor);
    valueAxis.renderer.line.strokeWidth = 1;
    valueAxis.renderer.line.strokeOpacity = 1;

    // Create series
    const series = this.chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = 'leader';
    series.dataFields.categoryX = 'session';
    series.name = 'leader';
    series.columns.template.tooltipText = 'Session {categoryX}: [bold]{valueY}[/]';
    series.tooltip.background.strokeOpacity = 0;
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color('white');
    series.tooltip.label.fill = am4core.color('black');
    series.columns.template.fillOpacity = 1;
    // series.columns.template.fill = am4core.color('#c4c4c4');
    series.columns.template.fill = am4core.color('#7abfe6');
    series.sequencedInterpolation = true;

    // Modifying Series
    const columnTemplate = series.columns.template;
    columnTemplate.strokeOpacity = 0;

    const hoverState = series.columns.template.states.create('hover');
    hoverState.properties.fillOpacity = 0.8;
    hoverState.properties.fill = am4core.color('#00ace2');
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>

<style lang="scss" scoped>
  #perSession {
    width: 100%;
    position: relative;
    display: flex;

    .leftLabel {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;
      width: 25px;
      margin-right: -20px;
      padding: 0 0 35px 0;
      box-sizing: border-box;

      .labelText {
        width: 300px;
        word-break: keep-all;
        white-space: pre;
        transform: rotate(-90deg);
        font-size: 12px;
        font-weight: bold;
      }
    }

    .graphWrap {
      width: 100%;

      .hello {
        width: 100%;
        height: 300px;
      }

      .bottomLabel {
        font-size: 12px;
        margin-top: -20px;
        font-weight: bold;
      }
    }

    .csTooltip {
      display: inline-block;
      position: absolute;
      top: 258px;
      left: calc(5% + 62px);
    }
  }
</style>

<style lang="scss">
  #welcomeOA {
    .hello {
      font-size: 12px;
    }
  }
</style>
